import { getColModelItem } from '../../../../services/lib/utils/helpers'
import { urlKey } from '../../../../services/api/api-urls'
import { ApiRequest } from '../../../../services/api/api'
import React, { useState, useEffect } from 'react'
import { Select, Spin } from 'antd'

// Action ID 和 Machine Type ID 的对应关系
const ACTION_TO_MACHINE_TYPE_MAP: { [key: number]: number } = {
	1: 1, // Printing → Printing
  	2: 2, // Die-Cutting → Die-cutting
  	3: 3, // Production → Production
  	4: 4  // Packaging → Packaging
}

// Machine select component with filtering based on action
const MachineEditComponent: React.FC<any> = (props) => {
  const [machines, setMachines] = useState<any[]>([])
  const [loading, setLoading] = useState(false)
  const [actionId, setActionId] = useState<number | null>(null)

  useEffect(() => {
    const fetchMachines = async () => {
      setLoading(true)
      try {
        // 获取当前行的 actionId - 支持多种字段名
        const currentActionId = props.rowData?.action?.actionId ||
                               props.rowData?.actionId ||
                               props.rowData?.action

        setActionId(currentActionId)

        // 获取所有机器
        const response = await ApiRequest({
          url: 'Machine/GetAllMachine',
          method: 'get'
        })
        const allMachines = response?.data?.data || []

        // 根据 actionId 过滤机器
        let filteredMachines = allMachines
        if (currentActionId && ACTION_TO_MACHINE_TYPE_MAP[currentActionId]) {
          const targetMachineTypeId = ACTION_TO_MACHINE_TYPE_MAP[currentActionId]
          filteredMachines = allMachines.filter((machine: any) => machine.machineTypeId === targetMachineTypeId)
        }

        setMachines(filteredMachines)
      } catch (error) {
        console.error('Failed to fetch machines:', error)
        setMachines([])
      } finally {
        setLoading(false)
      }
    }

    fetchMachines()
  }, [props.rowData?.action?.actionId, props.rowData?.actionId, props.rowData?.action])

  const handleChange = (value: any) => {
    props.onChange(value)
  }

  if (loading) {
    return <Spin size="small" />
  }

  return (
    <Select
      style={{ width: '100%' }}
      value={props.value}
      onChange={handleChange}
      placeholder="Select Machine"
      allowClear
      loading={loading}
      disabled={!actionId}
    >
      {machines.map((machine: any) => (
        <Select.Option key={machine.machineId} value={machine.machineId}>
          {machine.machineName}
        </Select.Option>
      ))}
    </Select>
  )
}

export default class MachineActionManagementColumnModel {
	static Column = [
		{
			title: 'Action Name',
			field: 'actionName',
			editable: 'never',
			render: (rowData: any) => (
				<div>
					{rowData.actionName || rowData.action?.actionName || '-'}
				</div>
			)
		},
		{
			...getColModelItem({
				title: 'Machine',
				field: urlKey.Machine,
				keywords: [
					urlKey.Machine
				]
			}, () => [{
				key: urlKey.Machine,
				label: '',
				otherOptions: {
					type: 'select'
				}
			}]),
			editComponent: (props: any) => <MachineEditComponent {...props} />,
			render: (rowData: any) => (
				<div>
					{rowData.machineName || rowData.machine?.machineName || '-'}
				</div>
			)
		},
		{
			title: 'Sequence',
			field: 'sequenceNo',
			editable: 'never',
			type: 'numeric',
			render: (rowData: any) => (
				<div style={{ textAlign: 'center' }}>
					{rowData.sequenceNo || rowData.sequence || 0}
				</div>
			)
		}
	]
}
